export enum PackageItemLimitType {
    Boolean = 1,
    Limit = 2
}